import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-page-header',
  templateUrl: './app-page-header.component.html',
  styleUrls: ['./app-page-header.component.scss']
})
export class AppPageHeaderComponent implements OnInit {

  @Input() title: string;
  @Input() icon: string;
  @Input() iconLink: string;
  @Input() showButton: boolean;
  @Input() confirmDialogRequired = false;
  returnUrl: string;
  confirmAddAf = false;

  constructor(
    private router: Router) { }

  ngOnInit() {
  }

  cancel() {
    if (this.confirmDialogRequired) {
      this.confirmAddAf = true;
      return;
    }
    this.router.navigate([this.iconLink]);
  }

  confirmYes() {
    this.confirmAddAf = false;
    this.router.navigate([this.iconLink]);
  }

  confirmNo() {
    this.confirmAddAf = false;
  }
}
